export const emailConfirmationPath = '/confirm-email';
export const identityServerRedirectPath = '/signin-oidc';
export const searchPath = '/sign';
export const detailsPath = '/details';
export const proofPath = '/proof';
export const walletsPath = '/wallets';
export const recordsPath = '/records';
export const newRecordPath = `${recordsPath}/new`;
export const recordDetailsPath = `${recordsPath}/:id`;
